import { useMemo } from 'react'
import { Box, Flex, Avatar, Heading, Text, Pluralize } from 'ui'
import { BriefcaseIcon, HeartIcon, StarIcon } from 'lucide-react'
import { format } from 'date-fns'

export function WorkerCardContent(props: {
  data: {
    id: number
    name: string
    numShiftsForCompany: number
    rating: number
    workForCompany: {
      startedAt: string | null
    }[]
    statusForCompany: string | null
    profilePicUrl: string
  }
}) {
  const { data } = props
  const lastShift = useMemo(() => {
    if (data.workForCompany && data.workForCompany.length > 0) {
      const startedAt = data.workForCompany[0].startedAt
      if (!startedAt) {
        return null
      }
      return new Date(startedAt)
    }

    return null
  }, [data])

  const statItems = useMemo(() => {
    const items: React.ReactNode[] = []

    if (data.statusForCompany === 'favorite') {
      items.push(<HeartIcon key="favorite" size={16} fill="currentColor" />)
    }

    if (data.rating) {
      items.push(
        <Flex
          key="rating"
          display={'inline-flex'}
          alignItems={'center'}
          gap={1}
        >
          <StarIcon size={16} />
          <Text as={'span'}>{Number(data.rating).toFixed(2)}</Text>
        </Flex>
      )
    }

    if (data.numShiftsForCompany) {
      items.push(
        <Text as={'span'} key="shifts">
          <Pluralize
            count={data.numShiftsForCompany}
            oneText={'shift'}
            manyText={'shifts'}
          />
        </Text>
      )
    }

    if (lastShift) {
      items.push(
        <Flex
          key="last-shift"
          display={'inline-flex'}
          alignItems={'center'}
          gap={1}
        >
          <BriefcaseIcon size={16} />
          <Text as={'span'}>
            Last Shift: {format(lastShift, 'MMM d, yyyy')}
          </Text>
        </Flex>
      )
    }

    return items
  }, [data.statusForCompany, data.rating, data.numShiftsForCompany, lastShift])

  return (
    <>
      <Avatar
        size={'xlarge'}
        user={{
          userId: data.id.toString(),
          name: data.name,
          photoUrl: data.profilePicUrl,
        }}
      />
      <Box pl={3} pt={[0, 1]} flex={1}>
        <Flex>
          <Heading level={4} my={0}>
            {data.name}
          </Heading>
          <Box flex={1} />
        </Flex>
        {statItems.length > 0 ? (
          <Box mt={2}>
            <Flex flexDirection={'row'} flexWrap={'wrap'} alignItems={'center'}>
              {statItems.map((item, index) => (
                <Flex key={index} display={'inline-flex'} alignItems={'center'}>
                  {index > 0 ? <Text as={'span'}>&nbsp;•&nbsp;</Text> : null}
                  {item}
                </Flex>
              ))}
            </Flex>
          </Box>
        ) : null}
      </Box>
    </>
  )
}
